import { createModule, from, makeAsset } from "../../utils";

export const iofc = createModule("iofc", {
  page: {
    ...from("title"),
    alert: from("title", "description")
  },
  form: {
    ...from("title", "empty"),
    validation: from("required"),
    label: from(
      "range",
      "avgFeedCost",
      "avgMilkPrice",
      "milkYieldSource",
      "milkFatSource",
      "milkProteinSource",
      "submit",
      "add",
      "remove",
      "scenario",
      "simulation",
      "milkPickups",
      "milkClass"
    )
  },
  chart: {
    ...from("title", "scenario", "today"),
    kpi: makeAsset
  }
});
